/** @format */

/* eslint-disable */
import React from 'react'
import localize from '../../../../Global/Localize'
import { formatDate } from '../../../../Helpers/formatters'
import ModalTemplate from '../../../ModalTemplate/ModalTemplate'
import ReversalBatchEntries from '../../BatchEntries/ReversalBatchEntries/ReversalBatchEntries'

const ViewReversalBatchModal = ({ reversal, handleClose, mode }) => {
  return (
    <ModalTemplate
      modalTitle="reversal"
      hideUpdate
      cancelText="close"
      modalMode={mode}
      handleClose={handleClose}
      modalClassName="modal-xl"
    >
      <div className="row g-3">
        <div className="col-md-4">
          <div className="d-flex align-items-center">
            <label className="text-capitalize col-4">
              {localize('batchNumber')}
            </label>
            <input
              type="text"
              className="form-control"
              value={reversal?.paddedBatchNumber || ''}
              disabled
            />
          </div>
        </div>
        <div className="col-md-4">
          <div className="d-flex align-items-center">
            <label className="text-capitalize col-4">
              {localize('valueDate')}
            </label>
            <input
              type="text"
              className="form-control"
              value={reversal?.valueDate || ''}
              disabled
            />
          </div>
        </div>
        <div className="col-md-4">
          <div className="d-flex align-items-center">
            <label className="text-capitalize col-4">
              {localize('remarks')}
            </label>
            <input
              type="text"
              className="form-control"
              value={reversal?.remarks || ''}
              disabled
            />
          </div>
        </div>
        <div className="col-md-4">
          <div className="d-flex align-items-center">
            <label className="text-capitalize col-4">
              {localize('createdBy')}
            </label>
            <input
              type="text"
              className="form-control"
              value={reversal?.createdBy || ''}
              disabled
            />
          </div>
        </div>
        <div className="col-md-4">
          <div className="d-flex align-items-center">
            <label className="text-capitalize col-4">
              {localize('createdDate')}
            </label>
            <input
              type="text"
              className="form-control"
              value={formatDate(reversal?.createdDate) || ''}
              disabled
            />
          </div>
        </div>
        <div className="col-md-4">
          <div className="d-flex align-items-center">
            <label className="text-capitalize col-4">
              {localize('status')}
            </label>
            <input
              type="text"
              className="form-control"
              value={reversal?.statusDescription || ''}
              disabled
            />
          </div>
        </div>
        <div className="col-md-4">
          <div className="d-flex align-items-center">
            <label className="text-capitalize col-4">
              {localize('verifiedBy')}
            </label>
            <input
              type="text"
              className="form-control"
              value={reversal?.auditedBy || ''}
              disabled
            />
          </div>
        </div>
        <div className="col-md-4">
          <div className="d-flex align-items-center">
            <label className="text-capitalize col-4">
              {localize('verifiedDate')}
            </label>
            <input
              type="text"
              className="form-control"
              value={formatDate(reversal?.auditedDate) || ''}
              disabled
            />
          </div>
        </div>
        <div className="col-md-4">
          <div className="d-flex align-items-center">
            <label className="text-capitalize col-4">
              {localize('verificationRemarks')}
            </label>
            <input
              type="text"
              className="form-control"
              value={reversal?.auditRemarks || ''}
              disabled
            />
          </div>
        </div>
        <div className="col-md-4">
          <div className="d-flex align-items-center">
            <label className="text-capitalize col-4">
              {localize('authorizedBy')}
            </label>
            <input
              type="text"
              className="form-control"
              value={reversal?.authorizedBy || ''}
              disabled
            />
          </div>
        </div>
        <div className="col-md-4">
          <div className="d-flex align-items-center">
            <label className="text-capitalize col-4">
              {localize('verifiedDate')}
            </label>
            <input
              type="text"
              className="form-control"
              value={formatDate(reversal?.authorizedDate) || ''}
              disabled
            />
          </div>
        </div>
        <div className="col-md-4">
          <div className="d-flex align-items-center">
            <label className="text-capitalize col-4">
              {localize('verificationRemarks')}
            </label>
            <input
              type="text"
              className="form-control"
              value={reversal?.authorizationRemarks || ''}
              disabled
            />
          </div>
        </div>
      </div>
      <div
        className="p-2 mt-4"
        style={{
          border: 'solid 1px #0000001f',
          borderRadius: 10,
          position: 'relative',
        }}
      >
        <div
          className="bg-white px-2  row text-capitalize"
          style={{
            position: 'relative',
            top: -20,
            left: 30,
            maxWidth: 'fit-content',
          }}
        >
          {localize('batchEntries')}
        </div>
        <div className="row mt-4">
          <ReversalBatchEntries
            showSelect={false}
            hiddenColumns={[0]}
            journalReversalBatchId={reversal?.id}
          />
        </div>
      </div>
    </ModalTemplate>
  )
}

export default ViewReversalBatchModal
